if (!customElements.get('compre-junto-carousel')) {
  class CompreJuntoCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      const slider = this.querySelector('.content-compre-junto');
      const progressTrack = this.querySelector('.compre-junto-progress__track');
      const progressThumb = this.querySelector('.compre-junto-progress__thumb');
      const prevBtn = this.querySelector('.compre-junto-arrow--prev');
      const nextBtn = this.querySelector('.compre-junto-arrow--next');

      if (!slider) return;

      const updateProgress = () => {
        if (!progressTrack || !progressThumb) return;

        const scrollWidth = slider.scrollWidth;
        const clientWidth = slider.clientWidth;
        const maxScroll = scrollWidth - clientWidth;

        if (maxScroll <= 1) {
          progressThumb.style.width = '100%';
          progressThumb.style.marginLeft = '0%';
          return;
        }

        const thumbPercent = Math.max((clientWidth / scrollWidth) * 100, 8);
        const leftPercent = (slider.scrollLeft / maxScroll) * (100 - thumbPercent);

        progressThumb.style.width = thumbPercent + '%';
        progressThumb.style.marginLeft = leftPercent + '%';
      };

      const updateNavVisibility = () => {
        const isDesktop = window.matchMedia('(min-width: 990px)').matches;
        const productCount = slider.querySelectorAll('.compre-junto-card').length;
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        const hideNav = isDesktop && productCount <= 3 && maxScroll <= 1;

        this.classList.toggle('compre-junto--no-nav', hideNav);
      };

      const updateButtons = () => {
        if (!prevBtn || !nextBtn) return;

        const maxScroll = slider.scrollWidth - slider.clientWidth;

        if (maxScroll <= 1) {
          prevBtn.disabled = true;
          nextBtn.disabled = true;
          return;
        }

        const EPS = 5;
        prevBtn.disabled = slider.scrollLeft <= EPS;
        nextBtn.disabled = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - EPS;
      };

      const equalizeCardHeights = () => {
        const cards = slider.querySelectorAll('.compre-junto-card');
        if (!cards.length) return;

        cards.forEach((card) => {
          card.style.minHeight = '';
        });

        let maxHeight = 0;
        cards.forEach((card) => {
          maxHeight = Math.max(maxHeight, card.offsetHeight);
        });

        cards.forEach((card) => {
          card.style.minHeight = maxHeight + 'px';
        });
      };

      const refresh = () => {
        equalizeCardHeights();
        updateNavVisibility();
        updateButtons();
        updateProgress();
      };

      const trackProgressDuringScroll = () => {
        let frame = 0;
        const tick = () => {
          updateProgress();
          updateButtons();
          frame += 1;
          if (frame < 90) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      };

      const scroll = (direction) => {
        const card = slider.querySelector('.compre-junto-card');
        const gap = parseFloat(getComputedStyle(slider).gap) || 16;
        const scrollAmount = card ? card.offsetWidth + gap : 220;

        slider.scrollBy({
          left: direction === 'next' ? scrollAmount : -scrollAmount,
          behavior: 'smooth',
        });

        trackProgressDuringScroll();
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', () => scroll('prev'));
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => scroll('next'));
      }

      slider.addEventListener(
        'scroll',
        () => {
          updateButtons();
          updateProgress();
        },
        { passive: true }
      );

      if ('onscrollend' in slider) {
        slider.addEventListener('scrollend', refresh);
      }

      this._onResize = refresh;
      window.addEventListener('resize', this._onResize);

      slider.querySelectorAll('img').forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', refresh, { once: true });
        }
      });

      if (typeof ResizeObserver !== 'undefined') {
        this._resizeObserver = new ResizeObserver(() => {
          requestAnimationFrame(refresh);
        });
        this._resizeObserver.observe(slider);
      }

      this.dataset.initialized = 'true';

      refresh();
      requestAnimationFrame(refresh);
      setTimeout(refresh, 150);
      setTimeout(refresh, 600);
    }

    disconnectedCallback() {
      if (this._onResize) {
        window.removeEventListener('resize', this._onResize);
      }

      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
      }
    }
  }

  customElements.define('compre-junto-carousel', CompreJuntoCarousel);
}
